import { Box, Center, Tabs } from "@mantine/core";
import React from "react";
import McBimFilePage from "./McBimFilePage/McBimFilePage";
import { useGetProjectQuery } from "../../../projectRTK";
import { useGetMcBimProjectQuery } from "./McBimRTK";
import { getProjectIdFromUrl } from "../../../utils";
import { useHistory } from "react-router-dom";
import McBimConfigPage from "./McBimConfigPage/McBimConfigPage";
import McBimMongoExtractedFiles from "./MCBimExtractedFiles/McBimMongoExtractedFiles";
import McBimJobbPage from "./McBimJobbPage/McBimJobbPage";
import McBimDocumentation from "../../../../components/DocumentMenu/McBimDocumentation";
import McBimActivate from "./McBimActivate";
import { FailedAlert, MCLoader } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { selectedFilesAndFilesSavedInMcBimIsEqual } from "./mcBimSlice";

const MCBIMSettingsPage = () => {
  const [activeTab, setActiveTab] = React.useState<
    "ACTIVE_FILES" | "SETTINGS" | "EXTRACTED_FILES" | "JOBS" | "DOCS"
  >("ACTIVE_FILES");

  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const { data: project } = useGetProjectQuery(projectId);
  const selectedFiles = useAppSelector((state) => state.mcBimReducer.selectedIfcFiles);

  const {
    data: mcbimProject,
    isLoading: mcbimProjectLoading,
    error: mcbimProjectError,
  } = useGetMcBimProjectQuery(projectId, {
    skip: project?.mcbim?.activated !== true,
  });

  const mcbimIsActivated = project?.mcbim?.activated;
  const hasUnsavedFileChanges =
    activeTab === "ACTIVE_FILES" &&
    mcbimProject != null &&
    selectedFilesAndFilesSavedInMcBimIsEqual(selectedFiles, mcbimProject.ifcFiles) === false;
  const unsavedChangesMessage = "Du har endringer som ikke er lagret til MCBIM. Vil du virkelig forlate siden?";

  const handleTabChange = (value: string | null) => {
    if (value == null || value === activeTab) {
      return;
    }

    if (hasUnsavedFileChanges && window.confirm(unsavedChangesMessage) === false) {
      return;
    }

    setActiveTab(value as typeof activeTab);
  };

  return (
    <Box h="100%" style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
      {mcbimProjectLoading && <MCLoader />}
      {mcbimIsActivated && mcbimProjectError && <FailedAlert />}
      {mcbimIsActivated !== true && (
        <Center h="100%" pt="xl">
          <Box w="100%" maw={560}>
            <McBimActivate />
          </Box>
        </Center>
      )}
      {mcbimIsActivated && mcbimProject != null && project != null && (
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
        >
          <Tabs.List px="sm" pt="sm">
            <Tabs.Tab value="ACTIVE_FILES">Aktive filer</Tabs.Tab>
            <Tabs.Tab value="SETTINGS">Innstillinger</Tabs.Tab>
            <Tabs.Tab value="JOBS">Synkronisering</Tabs.Tab>
            <Tabs.Tab value="EXTRACTED_FILES">Hentede data</Tabs.Tab>
            <Tabs.Tab value="DOCS">PowerBI</Tabs.Tab>
          </Tabs.List>

          <Box style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            <Tabs.Panel value="ACTIVE_FILES" h="100%">
              <McBimFilePage project={project} mcbimProject={mcbimProject} />
            </Tabs.Panel>
            <Tabs.Panel value="SETTINGS" h="100%">
              <McBimConfigPage project={project} mcBimProject={mcbimProject} />
            </Tabs.Panel>
            <Tabs.Panel value="JOBS" h="100%">
              <McBimJobbPage project={project} mcbimProject={mcbimProject} />
            </Tabs.Panel>
            <Tabs.Panel value="EXTRACTED_FILES" h="100%">
              <McBimMongoExtractedFiles
                project={project}
                mcBimProject={mcbimProject}
                isActive={activeTab === "EXTRACTED_FILES"}
              />
            </Tabs.Panel>
            <Tabs.Panel value="DOCS">
              <McBimDocumentation />
            </Tabs.Panel>
          </Box>
        </Tabs>
      )}
    </Box>
  );
};

export default MCBIMSettingsPage;
